import React from 'react';

const InfoIconFill = ({ className = '', fill = 'var(--primary-color)' }: any) => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.79922 9.50007C1.79922 7.59051 2.55779 5.75916 3.90805 4.4089C5.25831 3.05864 7.08966 2.30007 8.99922 2.30007C10.9088 2.30007 12.7401 3.05864 14.0904 4.4089C15.4407 5.75917 16.1992 7.59051 16.1992 9.50007C16.1992 11.4096 15.4406 13.241 14.0904 14.5912C12.7401 15.9415 10.9088 16.7001 8.99922 16.7001C7.08966 16.7001 5.25831 15.9415 3.90805 14.5912C2.55779 13.241 1.79922 11.4096 1.79922 9.50007ZM8.09922 5.90007C8.09922 5.66138 8.19404 5.43246 8.36282 5.26368C8.53161 5.09489 8.76052 5.00007 8.99922 5.00007C9.23791 5.00007 9.46683 5.09489 9.63562 5.26368C9.8044 5.43246 9.89922 5.66138 9.89922 5.90007C9.89922 6.13877 9.8044 6.36769 9.63562 6.53647C9.46683 6.70525 9.23791 6.80007 8.99922 6.80007C8.76052 6.80007 8.53161 6.70525 8.36282 6.53647C8.19404 6.36769 8.09922 6.13877 8.09922 5.90007ZM8.99922 14.0001C9.23791 14.0001 9.46683 13.9053 9.63561 13.7365C9.8044 13.5677 9.89922 13.3388 9.89922 13.1001L9.89922 9.50007C9.89922 9.26138 9.8044 9.03246 9.63562 8.86368C9.46683 8.69489 9.23791 8.60007 8.99922 8.60007C8.76052 8.60007 8.53161 8.69489 8.36282 8.86368C8.19404 9.03246 8.09922 9.26138 8.09922 9.50007L8.09922 13.1001C8.09922 13.3388 8.19404 13.5677 8.36282 13.7365C8.53161 13.9053 8.76052 14.0001 8.99922 14.0001Z"
      fill={fill}
    />
  </svg>
);

export default InfoIconFill;
